import IntercomContainer from './intercom.container'

export default IntercomContainer
